/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Select_Original_FailedInputs */

const en_audio_embed_export_select_original_failed = /** @type {(inputs: Audio_Embed_Export_Select_Original_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error selecting original media file`)
};

const fr_audio_embed_export_select_original_failed = /** @type {(inputs: Audio_Embed_Export_Select_Original_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la sélection du fichier multimédia d'origine`)
};

const de_audio_embed_export_select_original_failed = /** @type {(inputs: Audio_Embed_Export_Select_Original_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Auswählen der Originalmediendatei`)
};

const it_audio_embed_export_select_original_failed = /** @type {(inputs: Audio_Embed_Export_Select_Original_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante la selezione del file multimediale originale`)
};

const ru_audio_embed_export_select_original_failed = /** @type {(inputs: Audio_Embed_Export_Select_Original_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при выборе исходного медиафайла.`)
};

const es_audio_embed_export_select_original_failed = /** @type {(inputs: Audio_Embed_Export_Select_Original_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al seleccionar el archivo multimedia original`)
};

const zh_cn2_audio_embed_export_select_original_failed = /** @type {(inputs: Audio_Embed_Export_Select_Original_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择原始媒体文件时出错`)
};

const ja_audio_embed_export_select_original_failed = /** @type {(inputs: Audio_Embed_Export_Select_Original_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元のメディアファイルの選択中にエラーが発生しました。`)
};

const hi_audio_embed_export_select_original_failed = /** @type {(inputs: Audio_Embed_Export_Select_Original_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल मीडिया फ़ाइल का चयन करने में त्रुटि`)
};

const pt_pt2_audio_embed_export_select_original_failed = /** @type {(inputs: Audio_Embed_Export_Select_Original_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao selecionar o arquivo de mídia original`)
};

/**
* | output |
* | --- |
* | "Error selecting original media file" |
*
* @param {Audio_Embed_Export_Select_Original_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_select_original_failed = /** @type {((inputs?: Audio_Embed_Export_Select_Original_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Select_Original_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_select_original_failed(inputs)
	if (locale === "de") return de_audio_embed_export_select_original_failed(inputs)
	if (locale === "it") return it_audio_embed_export_select_original_failed(inputs)
	if (locale === "ru") return ru_audio_embed_export_select_original_failed(inputs)
	if (locale === "es") return es_audio_embed_export_select_original_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_select_original_failed(inputs)
	if (locale === "ja") return ja_audio_embed_export_select_original_failed(inputs)
	if (locale === "hi") return hi_audio_embed_export_select_original_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_select_original_failed(inputs)
	return en_audio_embed_export_select_original_failed(inputs)
});